// Sticky add-to-cart bar: shows once the main buy buttons scroll above the viewport,
// proxies its button to the real product form, and mirrors price + sold-out state.
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var sectionId = bar.getAttribute('data-section');
  var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
  var buyButtons = mainBtn ? mainBtn.closest('.product-form__buttons') : null;
  var addBtn = bar.querySelector('[data-sticky-add]');
  var label = bar.querySelector('[data-sticky-label]');
  var mainPrice = document.getElementById('price-' + sectionId);
  var stickyPrice = bar.querySelector('[data-sticky-price]');
  var visible = false;

  // The visible WhatsApp bubble (Dondy renders #whatsapp-widget-root > #chat-bubble).
  function getChatEl() {
    return document.getElementById('chat-bubble') || document.getElementById('whatsapp-widget-root');
  }

  // While the bar is open, lift the chat bubble up by raising its `bottom` (NOT its
  // transform — Dondy uses transform for its show animation, so touching it breaks the
  // widget). Only acts when the bubble is fixed with a px `bottom`; otherwise leaves it
  // completely alone.
  function shiftChatWidgets() {
    var chat = getChatEl();
    if (!chat) return;
    if (chat._origBottom === undefined) {
      var b = getComputedStyle(chat).bottom;
      chat._origBottom = b && b.indexOf('px') > -1 ? parseFloat(b) : null;
    }
    if (chat._origBottom === null) return; // positioned some other way — don't touch it
    if (visible) {
      chat.style.transition = 'bottom 0.3s ease';
      chat.style.setProperty('bottom', chat._origBottom + bar.offsetHeight + 16 + 'px', 'important');
    } else {
      chat.style.setProperty('bottom', chat._origBottom + 'px', 'important');
    }
  }

  function setVisible(v) {
    if (v === visible) return;
    visible = v;
    bar.classList.toggle('is-visible', v);
    bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    shiftChatWidgets();
    // Re-check shortly after, in case the chat widget script renders late.
    if (v) setTimeout(shiftChatWidgets, 400);
  }

  // Show the bar only after the buy buttons have scrolled ABOVE the viewport.
  if (buyButtons && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    ).observe(buyButtons);
  }

  // Proxy to the real Add to cart button (reuses variant, quantity, notification).
  if (addBtn && mainBtn) {
    addBtn.addEventListener('click', function () {
      mainBtn.click();
    });
  }

  // Keep the bar price in sync with the main price block (updates on variant change).
  if (mainPrice && stickyPrice && 'MutationObserver' in window) {
    var copyPrice = function () {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    };
    new MutationObserver(copyPrice).observe(mainPrice, { childList: true, subtree: true });
    copyPrice();
  }

  // Mirror sold-out / disabled state and button label (read the TEXT span, not the icon).
  if (mainBtn && addBtn) {
    var syncState = function () {
      addBtn.disabled = mainBtn.hasAttribute('disabled');
      var textSpan = mainBtn.querySelector('span:not(.svg-wrapper)');
      var t = textSpan ? textSpan.textContent.trim() : '';
      if (label && t) label.textContent = t;
    };
    syncState();
    new MutationObserver(syncState).observe(mainBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });
  }

  window.addEventListener('resize', shiftChatWidgets);
})();
